import { REHYDRATE } from 'redux-persist';
import { ANY_FIELD_UPDATE, updatedObject } from 'actions/formActions';
import {
  ADMIN_PANEL_INIT,
  ADMIN_PANEL_FETCH_BEGIN,
  ADMIN_PANEL_FETCH_FAIL,
  ADMIN_STATUS_UPDATE,
} from './types';
import INITIAL_STATE from './state';

export default function adminPanelReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return state;

    case ADMIN_PANEL_INIT:
      return {
        data: {
          companies: [],
          jobList: {},
          jobType: state.data ? state.data.jobType : 'inspection',
        },
        isFetching: false,
        isPosting: false,
      };

    case ADMIN_PANEL_FETCH_BEGIN: {
      const { status, failReason, ...newState } = state;

      return newState;
    }

    case ADMIN_PANEL_FETCH_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    case ANY_FIELD_UPDATE:
      if (action.storeName !== 'adminPanel') {
        return state;
      }

      return { ...state, data: updatedObject(state.data, action.accessPath, action.newVal) };

    case ADMIN_STATUS_UPDATE:
      return { ...state, status: action.status, hackedId: action.hackedId };

    default:
      return state;
  }
}
